/* eslint-disable no-alert */

import { api, stickyMessage } from './util';

(function ($) {
	$('#dis-analytic-show-dis').click(function () {
		$('#dis-search-form').submit();
	});

	let dis13FormValidation = function () {
		if ($('#dis-content input[name=usage]:checked').val() === 'custom') {
			// Missing Group By check
			let noGroupBy = true;

			$('#dis-content select[name=group-by]').each(function () {
				if ($(this).val() !== '') {
					noGroupBy = false;
				}
			});

			if (noGroupBy) {
				alert('Prosím vyberte alespoň jedno seskupení.');
				return false;
			}

			// Missing type of customer
			if ($('#dis-content input[name=customer-type]:checked').length === 0) {
				alert('Prosím vyberte nějaký typ distribuce');
				return false;
			}
		}

		if ($('#dis-content input[name=view-type]:checked').val() === undefined) {
			alert('Prosím zvolte, jakým způsobem chceme zobrazit data');
			return false;
		}

		if ($('#dis-content input[name=period]:checked').val() === undefined) {
			alert('Prosím zvolte periodu');
			return false;
		}
	};

	$('#dis-search-form').submit(function (event) {
		if (dis13FormValidation() === false) {
			return false;
		}

		$('#dis-analytic-submit').prop('disabled', true);
	});

	/**
	 * Generating .xls
	 */
	$(document).on('click', '.dis-module-js-export', function () {
		let btn = $(this);
		let originalText = btn.text();
		let url = btn.attr('data-href');
		let data = $('#dis-search-form').serialize();

		if (btn.hasClass('generating') || dis13FormValidation() === false) {
			return;
		}

		btn.addClass('generating');
		btn.text('Generuji .xls');

		api
			.get(`${url}?${data}`)
			.done(function (response) {
				if (response.status.success === false) {
					stickyMessage.show('error', response.status.message);
					return;
				}

				if (response.export.downloadUrl) {
					window.location.href = response.export.downloadUrl;
				} else {
					stickyMessage.show(
						'success',
						`Export je příliš velký. Po zpracování vám pošleme odkaz pro stažení na email ${response.export.asyncNotification.email}`
					);
				}
			})
			.always(function () {
				btn.removeClass('generating');
				btn.text(originalText);
			});

		return false;
	});
})(jQuery);
